<template>
  <Subscriptions
    :current-subscription="currentSubscription"
    @change-subscription="changeSubscriptionRequest"
  ></Subscriptions>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import Subscriptions from "../components/Subscriptions";
import { mapGetters } from "vuex";

export default {
  components: { Subscriptions },
  data: () => ({
    currentSubscription: ""
  }),
  created: async function() {
    await axios.get("/api/v1/subscriptions/current").then(res => {
      this.currentSubscription = res.data.name;
    });
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      themeDark: "settings/darkmode"
    })
  },
  methods: {
    async changeSubscriptionRequest(subscriptionName) {
      // if the user is on the Trial period sub and has zero balance, show them a message to deposit fuel first ->
      if (
        this.user.credit_gwei === 0 &&
        this.currentSubscription === "Trial period"
      ) {
        let confirmation = await swal({
          title: "Top-up needed",
          html: `<p>Before changing to a paid subscription plan, please top-up your GSMG account.</p>`,
          showCancelButton: true,
          confirmButtonText: "Top-up",
          showConfirmButton: true,
          showCloseButton: true,
          customClass: this.themeDark
            ? "swal-type-question-dark"
            : "swal-type-question"
        });

        if (confirmation.dismiss) {
          return false;
        }

        return await this.$router.push("/settings");
      }

      return await this.changeSubscription(subscriptionName);
    },
    async changeSubscription(subscriptionName) {
      try {
        let confirmation = await swal({
          title: "Change subscription?",
          confirmButtonText: "Confirm",
          html: `Please confirm that you want to switch to the non-free subscription: <strong>${subscriptionName}</strong>?`,
          showCancelButton: true,
          showConfirmButton: true,
          showCloseButton: true,
          customClass: this.themeDark
            ? "swal-type-question-dark"
            : "swal-type-question"
        });

        if (confirmation.dismiss) {
          // bail
          return false;
        }

        await axios.post(`/api/v1/subscriptions/change/${subscriptionName}`);
        await swal({
          title: "Subscription switch submitted",
          html:
            "You've successfully sent your subscription switch! When we have handled your switch successfully, you can find your new subscription on your dashboard.",

          showCloseButton: true,
          imageUrl: "/img/popup_img_success.png",
          imageHeight: 80,
          imageWidth: 80,
          customClass: this.themeDark ? "swal-type-success-dark" : "swal-type-success",
        });
      } catch (error) {
        if (error && error.response && error.response.status === 403) {
          await swal({
            title: "Too many markets selected",
            html: `You can not change your subscription to <strong>${subscriptionName}</strong> because you selected too many markets.
                 Please select another subscription or contact our support team!`,
            showConfirmButton: false,
            showCloseButton: true,
            customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });
        } else {
          await swal({
            title: "Error switching subscription",
            html:
              "There was a problem changing your subscription. Please try again or contact our support team!",
            showConfirmButton: false,
            showCloseButton: true,
            customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/subscriptions.vue